module.exports = __webpack_public_path__ + "static/media/DV.fe2d0221.png";